(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-grid"] && !Shopify.designMode) return;
  try {
    
  // This script block is self-contained and manages all interactive lookbook sections.
  // It's designed to be robust for Shopify's theme editor.
  (function() {
    // Desired visual speed for thumbnail auto-scroll (pixels per second)
    const THUMB_PIXELS_PER_SEC = 40;
    const initLookbookSection = (container) => {
      const fullSectionId = container.dataset.sectionId;
      if (!fullSectionId || container.dataset.lookbookInitialized) {
        return;
      }
      container.dataset.lookbookInitialized = true;
      
      // Extract the last part of the section ID to match the CSS classes
      const sectionId = fullSectionId.split('-').pop();
      console.log('Full section ID:', fullSectionId);
      console.log('Extracted section ID:', sectionId);

      const dataEl = container.querySelector(`#LookbookData-${sectionId}`);
      if (!dataEl) {
        // This section doesn't have lookbook data, skip it silently
        return;
      }
      
      let lookImages = [];
      try {
        const rawData = dataEl.textContent.trim();
        console.log('Raw lookbook data:', rawData);
        
        // Handle different data formats
        if (rawData.startsWith('[') && rawData.endsWith(']')) {
          // Already an array format
          lookImages = JSON.parse(rawData);
        } else {
          // String format - need to parse it properly
          console.log('Parsing string format data...');
          
          // Try to parse as JSON first (in case it's escaped)
          try {
            const parsed = JSON.parse(rawData);
            console.log('Successfully parsed as JSON, result type:', typeof parsed);
            
            // If the result is still a string, we need to parse it again
            if (typeof parsed === 'string') {
              console.log('Parsed result is a string, parsing again...');
              lookImages = JSON.parse(parsed);
            } else {
              lookImages = parsed;
            }
          } catch (e) {
            console.log('Failed to parse as JSON, trying manual parsing...');
            
            // Manual parsing for the specific format we're seeing
            let cleanData = rawData;
            
            // Remove outer quotes if present
            if (cleanData.startsWith('"') && cleanData.endsWith('"')) {
              cleanData = cleanData.slice(1, -1);
            }
            
            console.log('Clean data:', cleanData);
            
            // Use regex to extract URLs from the complex format
            const urlRegex = /"([^"]*\.(jpg|png|jpeg|webp)[^"]*?)"/g;
            const matches = [];
            let match;
            
            while ((match = urlRegex.exec(cleanData)) !== null) {
              let url = match[1];
              // Remove escaped characters
              url = url.replace(/\\/g, '');
              // Decode unicode escapes
              url = url.replace(/\\u0026/g, '&');
              matches.push(url);
            }
            
            lookImages = matches;
            console.log('Regex extracted URLs:', lookImages);
          }
        }
        
        console.log('Parsed lookbook images:', lookImages.length);
        console.log('Lookbook images array:', lookImages);
        console.log('Sample URLs:');
        
        // Ensure lookImages is an array before using array methods
        if (Array.isArray(lookImages)) {
          lookImages.slice(0, 3).forEach((url, index) => {
            console.log(`  ${index + 1}: ${url}`);
          });
        } else {
          console.error('lookImages is not an array:', typeof lookImages, lookImages);
        }
        
        // Ensure lookImages is always an array
        if (!Array.isArray(lookImages)) {
          console.error('lookImages is not an array:', typeof lookImages, lookImages);
          lookImages = [];
        }
      } catch (e) {
        console.error('Failed to parse lookbook data:', e);
        console.error('Raw data was:', dataEl.textContent);
        return;
      }

      const archiveRow = container.querySelector(`.collection-row-${sectionId}`);
      const thumbScroller = container.querySelector(`.thumbnail-scroller-${sectionId}`);
      const thumbTrack = container.querySelector(`.thumbnail-track-${sectionId}`);
      let viewer = container.querySelector(`.lookbook-viewer-${sectionId}`);
      let content = container.querySelector(`.lookbook-content-${sectionId}`);
      let track = container.querySelector(`.lookbook-inner-track-${sectionId}`);
      let closeBtn = container.querySelector(`.viewer-close-btn-${sectionId}`);
      let scrollIndicator = container.querySelector(`.scroll-indicator-${sectionId}`);

      console.log('Lookbook section initialized successfully:', sectionId);
      console.log('- Has thumbnail gallery:', !!archiveRow);
      console.log('- Has viewer wrapper:', !!viewer);
      console.log('- Has content area:', !!content);
      console.log('- Has image track:', !!track);
      console.log('- Has close button:', !!closeBtn);
      console.log('- Has scroll indicator:', !!scrollIndicator);

      if (!content || !track || !closeBtn || !scrollIndicator) {
        console.error('Missing required viewer elements for lookbook section:', sectionId);
        console.log('Available elements in container:', container.innerHTML.substring(0, 500) + '...');
        return;
      }

      // Check if viewer wrapper exists, if not create it
      if (!viewer) {
        console.warn('Viewer wrapper not found, creating one dynamically');
        viewer = document.createElement('div');
        viewer.className = `lookbook-viewer-${sectionId}`;
        viewer.style.position = 'fixed';
        viewer.style.top = '0';
        viewer.style.left = '0';
        viewer.style.width = '100vw';
        viewer.style.height = '100vh';
        viewer.style.backgroundColor = '#FFFFFF';
        viewer.style.zIndex = '9999';
        viewer.style.opacity = '0';
        viewer.style.visibility = 'hidden';
        viewer.style.transition = 'opacity 0.4s ease-in, visibility 0s 0.4s';
        
        // Move the content elements into the viewer
        const contentToMove = container.querySelector(`.lookbook-content-${sectionId}`);
        const uiToMove = container.querySelector(`.lookbook-ui-${sectionId}`);
        const indicatorToMove = container.querySelector(`.scroll-indicator-${sectionId}`);
        
        if (contentToMove) viewer.appendChild(contentToMove);
        if (uiToMove) viewer.appendChild(uiToMove);
        if (indicatorToMove) viewer.appendChild(indicatorToMove);
        
        document.body.appendChild(viewer);
        
        // Update element references since they might have been moved
        content = viewer.querySelector(`.lookbook-content-${sectionId}`);
        track = viewer.querySelector(`.lookbook-inner-track-${sectionId}`);
        closeBtn = viewer.querySelector(`.viewer-close-btn-${sectionId}`);
        scrollIndicator = viewer.querySelector(`.scroll-indicator-${sectionId}`);
        
        // Add CSS for visible state
        const style = document.createElement('style');
        style.textContent = `
          .lookbook-viewer-${sectionId}.visible {
            opacity: 1 !important;
            visibility: visible !important;
            transition: opacity 0.4s ease-in !important;
          }
        `;
        document.head.appendChild(style);
      }

      // Check if this section has a thumbnail gallery (archiveRow)
      if (!archiveRow) {
        console.warn('No thumbnail gallery found for section:', sectionId, '- this section may be view-only');
      }
      // Ensure all sections move at the same visual speed by setting animation duration
      const setThumbAnimationSpeed = () => {
        if (!thumbTrack) return;
        const trackWidth = thumbTrack.scrollWidth;
        if (!trackWidth) return;
        const singleSetWidth = trackWidth / 3; // We render 3 duplicate sets
        const seconds = Math.max(singleSetWidth / THUMB_PIXELS_PER_SEC, 1);
        thumbTrack.style.animationDuration = `${seconds}s`;
      };
      setThumbAnimationSpeed();
      // Recalculate on resize since widths can change responsively
      window.addEventListener('resize', setThumbAnimationSpeed);


      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let didDragViewer = false;
      let viewerDragDelta = 0;

      // Drag-to-scroll state for thumbnail scroller
      let isThumbDragging = false;
      let thumbStartX = 0;
      let thumbScrollLeft = 0;
      let thumbDidDrag = false; // used to suppress click-open after a drag
      let lastThumbDragAt = 0; // timestamp of the most recent drag movement
      const DRAG_CLICK_SUPPRESS_MS = 300;

      const handleScroll = () => {
        if (scrollIndicator) {
          scrollIndicator.style.opacity = '0';
        }
        
        // Handle infinite scroll
        const imageWidth = content.offsetWidth;
        const originalImageCount = lookImages.length;
        const totalImageCount = originalImageCount * 3; // We have 3 sets of images
        
        // If we're at the beginning (first set), jump to the middle set
        if (content.scrollLeft < imageWidth * originalImageCount * 0.5) {
          content.scrollLeft += imageWidth * originalImageCount;
        }
        // If we're at the end (last set), jump to the middle set
        else if (content.scrollLeft > imageWidth * originalImageCount * 2.5) {
          content.scrollLeft -= imageWidth * originalImageCount;
        }
      };

      // Track last focused element to restore focus on close
      let lastActiveElement = null;

      const openLookbook = (startIndex = 0) => {
        console.log('Opening lookbook for section:', sectionId, 'starting at index:', startIndex);
        console.log('lookImages type:', typeof lookImages);
        console.log('lookImages length:', lookImages.length);
        console.log('Total images in viewer will be:', lookImages.length * 3); // 3 sets for infinite scroll
        console.log('lookImages content:', lookImages);
        
        // Clear the track first
        track.innerHTML = '';
        
        // Create placeholder images if no real images are available
        if (lookImages.length === 0) {
          console.log('Creating placeholder images for testing');
          for (let i = 0; i < 5; i++) {
            const wrapper = document.createElement('div');
            wrapper.className = `lookbook-image-wrapper-${sectionId}`;
            
            const img = document.createElement('img');
            img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDQwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjRjBGMUYyIi8+Cjx0ZXh0IHg9IjIwMCIgeT0iMzAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiM5Q0EzQUYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5QbGFjZWhvbGRlcjwvdGV4dD4KPC9zdmc+';
            img.alt = 'Placeholder image';
            img.onload = () => console.log('Placeholder image loaded successfully');
            img.onerror = () => console.error('Failed to load placeholder image');
            wrapper.appendChild(img);
            track.appendChild(wrapper);
          }
        }
        
        // Load real images if available
        if (lookImages.length > 0) {
          console.log('Loading', lookImages.length, 'images into viewer with infinite scroll');
          
          // Add duplicate images at the end for infinite scroll
          const imagesForInfiniteScroll = [...lookImages, ...lookImages, ...lookImages];
          
          imagesForInfiniteScroll.forEach((src, index) => {
            const wrapper = document.createElement('div');
            wrapper.className = `lookbook-image-wrapper-${sectionId}`;
            
            const img = document.createElement('img');
            img.src = src;
            img.alt = 'Lookbook image';
            img.onload = () => console.log(`Image ${index + 1} loaded successfully`);
            img.onerror = () => console.error(`Failed to load image ${index + 1}:`, src);
            wrapper.appendChild(img);
            track.appendChild(wrapper);
          });
        }

        if (scrollIndicator) {
          scrollIndicator.style.opacity = '1';
        }
        viewer.classList.add('visible');
        viewer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Save focus and move focus to close button for accessibility
        lastActiveElement = document.activeElement;
        if (closeBtn && typeof closeBtn.focus === 'function') {
          setTimeout(() => closeBtn.focus(), 0);
        }
        
        // Scroll to the clicked image instantly (no animation) so it opens on that image
        setTimeout(() => {
          const prevBehavior = content.style.scrollBehavior;
          content.style.scrollBehavior = 'auto';
          const imageWidth = content.offsetWidth; // Width of one image (100vw)
          const originalImageCount = lookImages.length;
          const scrollPosition = (originalImageCount + startIndex) * imageWidth; // Start in the middle set
          content.scrollLeft = scrollPosition;
          // restore smooth scrolling after positioning
          content.style.scrollBehavior = prevBehavior || 'smooth';
          console.log('Jumped to image', startIndex, 'at position', scrollPosition, 'of', originalImageCount);
        }, 50);
        
        content.addEventListener('scroll', handleScroll);
        
        // Debug: Check if images were added
        setTimeout(() => {
          const imageWrappers = track.querySelectorAll(`.lookbook-image-wrapper-${sectionId}`);
          console.log('Image wrappers found in track:', imageWrappers.length);
          console.log('Track HTML:', track.innerHTML.substring(0, 300) + '...');
          imageWrappers.forEach((wrapper, index) => {
            const img = wrapper.querySelector('img');
            console.log(`Wrapper ${index}:`, wrapper, 'Image:', img);
          });
        }, 100);
      };

      const closeLookbook = () => {
        viewer.classList.remove('visible');
        viewer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        // Restore focus
        if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
          setTimeout(() => lastActiveElement.focus(), 0);
        }
      };

      const handleMouseDown = (e) => {
        isDown = true;
        content.classList.add('active');
        startX = e.pageX - content.offsetLeft;
        scrollLeft = content.scrollLeft;
        didDragViewer = false;
        viewerDragDelta = 0;
      };

      const handleMouseLeave = () => {
        isDown = false;
        content.classList.remove('active');
      };

      const handleMouseUp = () => {
        isDown = false;
        content.classList.remove('active');
        // Snap to the nearest image after a drag for smoother transition
        if (didDragViewer) {
          const imageWidth = content.offsetWidth;
          let targetIndex = Math.round(content.scrollLeft / imageWidth);
          // Bias toward next/prev with a small threshold so less movement is needed
          const BIAS_PX = 40;
          if (Math.abs(viewerDragDelta) > BIAS_PX) {
            targetIndex += Math.sign(viewerDragDelta);
          }
          const targetLeft = targetIndex * imageWidth;
          content.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
      };

      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - content.offsetLeft;
        const walk = (x - startX) * 3.2; // Higher sensitivity: smaller cursor moves scroll more
        content.scrollLeft = scrollLeft - walk;
        if (Math.abs(walk) > 3) didDragViewer = true;
        viewerDragDelta = content.scrollLeft - scrollLeft;
      };

      // Thumbnail scroller drag handlers (mouse)
      const handleThumbMouseDown = (e) => {
        if (!thumbScroller) return;
        isThumbDragging = true;
        thumbDidDrag = false;
        thumbScroller.classList.add('active');
        thumbStartX = e.pageX - thumbScroller.offsetLeft;
        thumbScrollLeft = thumbScroller.scrollLeft;
      };

      const handleThumbMouseMove = (e) => {
        if (!isThumbDragging || !thumbScroller) return;
        e.preventDefault();
        const x = e.pageX - thumbScroller.offsetLeft;
        const walk = (x - thumbStartX) * 2.0;
        if (Math.abs(walk) > 5) thumbDidDrag = true;
        thumbScroller.scrollLeft = thumbScrollLeft - walk;
        lastThumbDragAt = Date.now();
      };

      const handleThumbMouseUp = () => {
        if (!thumbScroller) return;
        isThumbDragging = false;
        // keep thumbDidDrag true briefly so click handler can read it
        setTimeout(() => { thumbDidDrag = false; }, 50);
        thumbScroller.classList.remove('active');
      };

      const handleThumbMouseLeave = () => {
        if (!thumbScroller) return;
        isThumbDragging = false;
        setTimeout(() => { thumbDidDrag = false; }, 50);
        thumbScroller.classList.remove('active');
      };

      // Thumbnail scroller drag handlers (touch)
      const handleThumbTouchStart = (e) => {
        if (!thumbScroller) return;
        const t = e.touches[0];
        isThumbDragging = true;
        thumbDidDrag = false;
        thumbScroller.classList.add('active');
        thumbStartX = t.pageX - thumbScroller.offsetLeft;
        thumbScrollLeft = thumbScroller.scrollLeft;
      };

      const handleThumbTouchMove = (e) => {
        if (!isThumbDragging || !thumbScroller) return;
        const t = e.touches[0];
        const x = t.pageX - thumbScroller.offsetLeft;
        const walk = (x - thumbStartX) * 2.0;
        if (Math.abs(walk) > 5) thumbDidDrag = true;
        thumbScroller.scrollLeft = thumbScrollLeft - walk;
        lastThumbDragAt = Date.now();
      };

      const handleThumbTouchEnd = () => {
        if (!thumbScroller) return;
        isThumbDragging = false;
        setTimeout(() => { thumbDidDrag = false; }, 50);
        thumbScroller.classList.remove('active');
      };

      // Attach all event listeners
      if (archiveRow) {
        // Add click listeners to individual thumbnails
        const thumbnails = archiveRow.querySelectorAll(`.thumbnail-item-${sectionId}`);
        const originalImageCount = lookImages.length;
        
        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent triggering the archiveRow click

            // If user dragged the strip, suppress click-to-open
            if (thumbDidDrag || (Date.now() - lastThumbDragAt) < DRAG_CLICK_SUPPRESS_MS) {
              e.preventDefault();
              return;
            }
            
            // Calculate the correct image index (accounting for infinite scroll duplicates)
            const actualImageIndex = index % originalImageCount;
            console.log('Thumbnail clicked:', index, '-> actual image index:', actualImageIndex);
            openLookbook(actualImageIndex);
          });

          // Keyboard activation for accessibility (Enter/Space)
          thumbnail.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const actualImageIndex = index % originalImageCount;
              openLookbook(actualImageIndex);
            }
          });
        });
        
        // Fallback click handler for the entire row
        archiveRow.addEventListener('click', (e) => {
          // Suppress fallback open if a drag just occurred
          if (thumbDidDrag || (Date.now() - lastThumbDragAt) < DRAG_CLICK_SUPPRESS_MS) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          openLookbook(0);
        });
      }
      // Attach thumbnail scroller listeners if present
      if (thumbScroller) {
        thumbScroller.addEventListener('mousedown', (e) => {
          // Prevent starting native image drag/select
          e.preventDefault();
          handleThumbMouseDown(e);
        });
        thumbScroller.addEventListener('mousemove', handleThumbMouseMove);
        thumbScroller.addEventListener('mouseup', handleThumbMouseUp);
        thumbScroller.addEventListener('mouseleave', handleThumbMouseLeave);
        thumbScroller.addEventListener('touchstart', handleThumbTouchStart, { passive: true });
        thumbScroller.addEventListener('touchmove', (e) => {
          // Prevent image dragging/scroll chaining when actively dragging
          if (isThumbDragging) e.preventDefault();
          handleThumbTouchMove(e);
        }, { passive: false });
        thumbScroller.addEventListener('touchend', handleThumbTouchEnd);
        thumbScroller.addEventListener('touchcancel', handleThumbTouchEnd);
        // Prevent default dragstart on images inside the scroller
        thumbScroller.addEventListener('dragstart', (e) => e.preventDefault());
      }
      closeBtn.addEventListener('click', closeLookbook);
      // Infinite scroll for thumbnail scroller: jump from ends to middle set
      if (thumbScroller && thumbTrack) {
        const updateThumbInfinite = () => {
          const singleSetWidth = thumbTrack.scrollWidth / 3; // 3 sets rendered
          const left = thumbScroller.scrollLeft;
          const maxLeft = left + thumbScroller.clientWidth;

          // If near the start, jump forward by one set
          if (left < singleSetWidth * 0.5) {
            thumbScroller.scrollLeft += singleSetWidth;
          }
          // If near the end, jump back by one set
          else if (maxLeft > singleSetWidth * 2.5) {
            thumbScroller.scrollLeft -= singleSetWidth;
          }
        };

        thumbScroller.addEventListener('scroll', updateThumbInfinite);

        // Accessibility: keep only middle duplicate (data-dup="1") tabbable
        const syncThumbAccessibility = () => {
          const items = thumbScroller.querySelectorAll(`.thumbnail-item-${sectionId}`);
          items.forEach((el) => {
            const dup = el.getAttribute('data-dup');
            if (dup === '1') {
              el.setAttribute('tabindex', '0');
              el.setAttribute('aria-hidden', 'false');
            } else {
              el.setAttribute('tabindex', '-1');
              el.setAttribute('aria-hidden', 'true');
            }
          });
        };
        syncThumbAccessibility();

        // Remap focus to middle-set equivalent when a non-middle duplicate gains focus
        thumbScroller.addEventListener('focusin', (e) => {
          const target = e.target && e.target.closest && e.target.closest(`.thumbnail-item-${sectionId}`);
          if (!target) return;
          const dup = target.getAttribute('data-dup');
          if (dup !== '1') {
            const idx = target.getAttribute('data-thumb-index');
            const middle = thumbScroller.querySelector(`.thumbnail-item-${sectionId}[data-dup="1"][data-thumb-index="${idx}"]`);
            if (middle) {
              e.preventDefault();
              middle.focus();
            }
          }
        });
        // Initialize position to the middle set on load for seamless loop
        requestAnimationFrame(() => {
          const singleSetWidth = thumbTrack.scrollWidth / 3;
          thumbScroller.scrollLeft = singleSetWidth;
        });
      }
      content.addEventListener('mousedown', handleMouseDown);
      content.addEventListener('mouseleave', handleMouseLeave);
      content.addEventListener('mouseup', handleMouseUp);
      content.addEventListener('mousemove', handleMouseMove);

      // Keyboard handling: Escape closes when viewer is visible
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (viewer && viewer.classList.contains('visible')) {
            e.preventDefault();
            closeLookbook();
          }
          return;
        }
        // Developer helper: Ctrl+L opens viewer
        if (e.key.toLowerCase && e.key.toLowerCase() === 'l' && e.ctrlKey) {
          e.preventDefault();
          openLookbook(0);
        }
      });

      // Development test button removed per request
    };

    const initAllLookbookSections = () => {
      document.querySelectorAll('[data-section-id]').forEach(initLookbookSection);
    };

    // Initialize on initial page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllLookbookSections);
    } else {
      initAllLookbookSections();
    }

    // Initialize on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.hasAttribute('data-section-id')) {
        initLookbookSection(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
